/**
 * Touch devices: apply desktop-like hover state on tap and keep it until
 * another tap elsewhere or navigation — not on finger release.
 *
 * Collection product cards: the whole card is the hit area (same as desktop
 * `.card-wrapper:hover`). Bare :hover stays desktop-only so iOS does not
 * sticky-swap the photo.
 */
(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (finePointer.matches) return;

  const INTERACTIVE_SELECTOR = [
    '.button',
    'a[class*="__button"]',
    'button[class*="__button"]',
    'a[class*="-button"]',
    'button[class*="-button"]',
    'button[class*="__tab"]',
    'button[class*="__arrow"]',
    'a[class*="__arrow"]',
    'a[class*="__card"]',
    'a[class*="__media-link"]',
    'a.ff-category-entry__media',
    'a[class*="__title-link"]',
  ].join(',');

  const isHomeMediaLink = (element) => element.classList.contains('ff-popular-products__media-link');

  const clearTouchHover = (except) => {
    document.querySelectorAll('.is-touch-hover').forEach((element) => {
      if (element !== except) element.classList.remove('is-touch-hover');
    });
  };

  const warmupSecondary = (card) => {
    const secondary = card.querySelector('[data-tt-card-image-secondary], .card__media .media img + img');
    if (!secondary) return;
    if (secondary.complete && secondary.naturalWidth > 0) return;
    secondary.setAttribute('loading', 'eager');
    if (typeof secondary.decode === 'function') {
      secondary.decode().catch(() => {});
    }
  };

  let activeCollectionCard = null;

  const clearCollectionCardHover = (except) => {
    document.querySelectorAll('.tt-collection-grid .card-wrapper.is-media-interactive').forEach((card) => {
      if (card !== except) card.classList.remove('is-media-interactive');
    });
    if (except) return;
    activeCollectionCard = null;
  };

  const activateCollectionCard = (card) => {
    warmupSecondary(card);
    clearCollectionCardHover(card);
    clearTouchHover(null);
    card.classList.add('is-media-interactive');
    activeCollectionCard = card;
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType !== 'touch') return;

      const collectionCard = event.target.closest('.tt-collection-grid .card-wrapper');
      if (collectionCard) {
        activateCollectionCard(collectionCard);
        return;
      }

      clearCollectionCardHover(null);

      const target = event.target.closest(INTERACTIVE_SELECTOR);
      if (target && isHomeMediaLink(target)) {
        clearTouchHover(null);
        return;
      }

      if (target) {
        clearTouchHover(target);
        target.classList.add('is-touch-hover');
        return;
      }

      clearTouchHover(null);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointercancel',
    (event) => {
      if (event.pointerType !== 'touch') return;
      if (activeCollectionCard) {
        activeCollectionCard.classList.remove('is-media-interactive');
        activeCollectionCard = null;
      }
    },
    { passive: true }
  );
})();
